module.exports = function getResource(label) {
    const resources = {
        gotIt: 'Compris',
        curbsideConcierge: 'Concierge pour ramassage à l’extérieur',
        whatItIs: 'Qu’est-ce que c’est',
        whatToDo: 'Quoi faire',
        curbsideConciergeAltText: 'Curbside Concierge Icon',
        inStorePickupAltText: 'In Store Pickup Icon'
    };

    return resources[label];
};
